import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Button
} from 'reactstrap'
import moment from 'moment'
import TimePicker from 'rc-time-picker'
import 'rc-time-picker/assets/index.css'

class FieldTime extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      time: props.cardField.fieldValue ?
            moment(props.cardField.fieldValue, 'HH:mm:ss').format('HH:mm:ss') : null
    }

    this.toggleTimepicker = this.toggleTimepicker.bind(this)
    this.openTimepicker = this.openTimepicker.bind(this)
    this.clearValue = this.clearValue.bind(this)
    this.handleTimeChange = this.handleTimeChange.bind(this)
    this.returnValue = this.returnValue.bind(this)
  }

  toggleTimepicker(ev) {
    ev && ev.preventDefault && ev.preventDefault()

    this.setState(prevState => {
      return {
        open: !prevState.open
      }
    })
  }

  openTimepicker() {
    this.setState({
      open: true
    })
  }

  clearValue(ev) {
    ev.preventDefault()

    this.setState({
      open: false,
      time: null
    })
  }

  handleTimeChange(momentObj) {
    this.setState({
      time: momentObj ? momentObj.format('HH:mm:ss') : null
    })
  }

  returnValue() {
    return this.state.time
  }

  render() {
    const fieldClassName = `card-field field-datetime ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    let timePickerFooter = panel => {
      return <div className="time-picker-footer p-2 text-right">
        <Button color="primary" onClick={this.toggleTimepicker}>Ok</Button>
        <Button color="danger" outline className="float-left" onClick={this.clearValue}><i className="icon-trash"></i></Button>
      </div>
    }

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <TimePicker
        open={this.state.open}
        className="mb-3"
        format='HH:mm'
        showSecond={false}
        onChange={this.handleTimeChange}
        defaultOpenValue={moment('09:00', 'h:mm')}
        allowEmpty={false}
        addon={timePickerFooter}
        value={this.state.time ? moment(this.state.time, 'HH:mm:ss') : null}
        onOpen={this.openTimepicker}
        onClose={this.toggleTimepicker}
        />
        {' '}<i className="icon-clock" onClick={this.toggleTimepicker}></i>
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <div className="mb-3">{this.props.cardField.fieldValue !== 'null' && this.props.cardField.fieldValue !== null ? moment(this.props.cardField.fieldValue, 'HH:mm:ss').format('HH:mm') : null}</div>
    </div>
  }
}

FieldTime.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldTime.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldTime


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldTime.js